import { parse } from 'qs'

export const getCorpId = () => {
  const { search } = window.location
  const searchs = parse(search, { ignoreQueryPrefix: true })
  const corpId = searchs.corpid || searchs.corpId
  if (corpId) {
    localStorage.setItem('CORP_ID', corpId)
    return corpId
  }
  return localStorage.getItem('CORP_ID')
}

// 时间格式化
export const getDate = (
  nDate = (new Date()), tmpFmt = 'yyyy-MM-dd hh:mm:ss'
) => {
  const tmpDate = new Date(nDate)
  const sDate = Number.isNaN(tmpDate) ? new Date() : tmpDate
  let fmt = Number.isNaN(tmpDate) ? nDate : tmpFmt
  const dateObj = {
    'M+': sDate.getMonth() + 1,
    'd+': sDate.getDate(),
    'h+': sDate.getHours(),
    'm+': sDate.getMinutes(),
    's+': sDate.getSeconds(),
    'q+': Math.floor((sDate.getMonth() + 3) / 3),
    S: sDate.getMilliseconds()
  }
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (`${sDate.getFullYear()}`)
      .substr(4 - RegExp.$1.length))
  }
  for (const s in dateObj) {
    if (new RegExp(`(${s})`).test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1)
        ? (dateObj[s])
        : ((`00${dateObj[s]}`).substr((`${dateObj[s]}`).length)))
    }
  }
  return fmt
}

const htmlEncodeList = {
  // ' ': '&nbsp;',
  '\'': '&quot;',
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;'
}
// const htmlEncodeReg = /( |'|&|<|>)/g
const htmlEncodeReg = /('|&|<|>)/g
const htmlDecodeList = {
  // '&nbsp;': ' ',
  '&quot;': '\'',
  '&amp;': '&',
  '&lt;': '<',
  '&gt;': '>'
}
// const htmlDecodeReg = /(&nbsp;|&quot;|&amp;|&lt;|&gt;)/g
const htmlDecodeReg = /(&quot;|&amp;|&lt;|&gt;)/g

export const htmlEncode = str => str.replace(htmlEncodeReg, s => htmlEncodeList[s])

export const htmlDecode = str => str.replace(htmlDecodeReg, s => htmlDecodeList[s])

const loadImg = (className, src) => {
  return new Promise((resolve, reject) => {
      let img = new Image()
      img.src = src
      img.onload = function() {
          let image = document.createElement('img')
          image.src = this.src
          const Div = document.getElementsByClassName(className)[0]
          Div.appendChild(image)
          resolve(true)
      }
  })
}

// 顺序加载图片
export const orderLoadImg = (className, images) => {
  if (images.length > 0) {
      loadImg(className, images[0]).then(res => {
        orderLoadImg(className, images.splice(1)) // 索引为 0 的图片已加载，所以我们还需要加载索引为 1 到末尾的图片
      })
  }
}
